import { render } from "./AdminAddConsultant.vue?vue&type=template&id=2a29ac91&scoped=true&ts=true"
import script from "./AdminAddConsultant.vue?vue&type=script&lang=ts"
export * from "./AdminAddConsultant.vue?vue&type=script&lang=ts"

import "./AdminAddConsultant.vue?vue&type=style&index=0&id=2a29ac91&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a29ac91"]])

export default __exports__